import trim from 'mn-utils/trim';
import {CURRENCY_ITEMS} from '../../../../../constants';
import Popup from '../../../../dumb/Popup/C';
import Select3 from '../../../../dumb/Select/B';
import TextField from '../../../../dumb/TextField/H';
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import handleProviderProvider from 'mn-utils/changeProviderProviderSimple';
import AddIcon from '../../../../icons/Plus';
import {
  openPopupWindow,
  openV1PopupInfo,
} from '../../../../../emitters/popup';
import ResendMoneyIcon from '../../../../icons/ResendMoney';
import SendIcon from '../../../../icons/Send';
import Ripple from '../../../../dumb/Ripple';
import ButtonBack from '../../../../dumb/Button/Back';
import CaptionA from '../../../../dumb/Caption/A';
import HeaderA from '../../../../dumb/Header/A';
import LayoutB from '../../../../dumb/Layout/B';
import React from 'react';
import {
  backLocation,
} from '../../../../../router';
import Field from '../../../../dumb/Field/A';
import Tooltip from '../../../../dumb/Tooltip/A';
import WrapperWithLoading from '../../../../dumb/WrapperWithLoading';
import TransactionsTable from './TransactionsTable';
import {
  apiAdminPayoutNiumManualRefreshTransaction,
  apiAdminPayoutNiumManualUpdate,
  apiAdminPayoutNiumStartDirect,
  apiAdminPayoutNiumGet,
} from '../../../../../api/admin/payout/nium';
import withState from '../../../../../utils/withState';
import {
  PAYOUT_PROGRESS_DESCRIPTION_MAP,
  PAYOUT_PROGRESS_TITLE_MAP,
  PAYOUT_STATUS_CLASS_MAP,
} from './../constants';

const STATUSES = [
  'IN_PROCESS',
  'AWAITING_FUNDS',
  'COMPILANCE_VERIFICATION',
  'COMPILANCE_REJECTED',
  'COMPILANCE_APPROVED',
  'INFO_REQUESTED',
  'PG_PROCESSING',
  'PAID',
  'RETURNED',
  'CANCELED',
  'ERROR',
  'USER_REJECTED',
];

const REMITTER_IDENTIFICATION_TYPES = [
  'Registration Number',
  'Registration ID',
  'ACRA',
  'Travel Agent License number',
  'Company Registration No',
  'License No',
  'ARNU',
  'DRLC',
  'NIDN',
  'CCPT',
];

const BENEFICIARY_IDENTIFICATION_TYPES = [
  'Company Organization Code',
  'Company Social Credit Code',
  'Passport',
  'Company Registration No.',
  'CUIT',
  'CUIL',
  'CPF',
  'CNPJ',
  'RUT',
  'CC',
  'NIT',
  'CE',
  'PASS',
  'DNI',
  'RUC',
  'CI',
];

module.exports = withState((setState, self, onMount) => {
  const payoutId = self.props.params.id;

  onMount(() => {
    setState({loading: true});
    apiAdminPayoutNiumGet({payout_id: payoutId}).then((payout) => {
      setState({
        loading: false,
        merchantId: payout.merchant_id,
        merchantName: payout.merchant_name,
        merchantEmail: payout.merchant_email,
        currency: payout.currency,
        amount: payout.amount,
        fee: payout.fee,
        status: payout.status,
        progress: payout.progress,
        transactions: payout.tx_attempts,
      });
    });
  });

  const openAddManualTransactionWindow = (payoutId) => {
    openPopupWindow((setPopupState, popup) => {
      const {
        close,
      } = popup;
      popup.state = {
        clicked: false,
      };

      const changeProvider = changeProviderProvider(setPopupState);
      const handleProvider = handleProviderProvider(setPopupState);

      const handleChangeTxNumber = handleProvider('txNumber');
      const handleChangeStatus = changeProvider('status');
      const handleChangeSubStatus = handleProvider('subStatus');
      const handleChangeStatusDescription = handleProvider('statusDescription');

      // Remitter
      const handleChangeRemitterNiumAccountId = handleProvider('remitterNiumAccountId');
      const handleChangeRemitterFiatCode = changeProvider('remitterFiatCode');
      const handleChangeRemitterName = handleProvider('remitterName');
      const handleChangeRemitterIdentificationType = handleProvider('remitterIdentificationType');
      const handleChangeRemitterIdentificationNumber = handleProvider('remitterIdentificationNumber');
      const handleChangeCountryCode = changeProvider('remitterCountryCode');
      const handleChangeRemitterAddress = handleProvider('remitterAddress');
      const handleChangeRemitterSourceOfIncome = handleProvider('remitterSourceOfIncome');
      const handleChangeRemitterContactNumber = handleProvider('remitterContactNumber');
      const handleChangeRemitterDob = handleProvider('remitterDob');
      const handleChangeRemitterCity = handleProvider('remitterCity');
      const handleChangeRemitterPostcode = handleProvider('remitterPostcode');
      const handleChangeRemitterState = handleProvider('remitterState');
      const handleChangeRemitterSourceOfFunds = handleProvider('remitterSourceOfFunds');
      const handleChangeRemitterPlaceOfBirth = handleProvider('remitterPlaceOfBirth');
      const handleChangeRemitterNationality = handleProvider('remitterNationality');
      const handleChangeRemitterOccupation = handleProvider('remitterOccupation');

      // Beneficiary
      const handleChangeBeneficiaryMerchantId = changeProvider('beneficiaryMerchantId');
      const handleChangeBeneficiaryName = changeProvider('beneficiaryName');
      const handleChangeBeneficiaryAddress = changeProvider('beneficiaryAddress');
      const handleChangeBeneficiaryCity = changeProvider('beneficiaryCity');
      const handleChangeBeneficiaryState = changeProvider('beneficiaryState');
      const handleChangeBeneficiaryPostcode = changeProvider('beneficiaryPostcode');
      const handleChangeBeneficiaryCountryCode = changeProvider('beneficiaryCountryCode');
      const handleChangeBeneficiaryEmail = changeProvider('beneficiaryEmail');
      const handleChangeBeneficiaryAccountType = changeProvider('beneficiaryAccountType');
      const handleChangeBeneficiaryContactNumber = changeProvider('beneficiaryContactNumber');
      const handleChangeBeneficiaryDob = changeProvider('beneficiaryDob');
      const handleChangeBeneficiaryWalletId = changeProvider('beneficiaryWalletId');
      const handleChangeBeneficiaryAccountNumber = changeProvider('beneficiaryAccountNumber');
      const handleChangeBeneficiaryBankAccountType = changeProvider('beneficiaryBankAccountType');
      const handleChangeBeneficiaryBankName = changeProvider('beneficiaryBankName');
      const handleChangeBeneficiaryBankCode = changeProvider('beneficiaryBankCode');
      const handleChangeBeneficiaryIdentificationType = changeProvider('beneficiaryIdentificationType');
      const handleChangeBeneficiaryIdentificationValue = changeProvider('beneficiaryIdentificationValue');
      const handleChangeBeneficiaryCardNumber = changeProvider('beneficiaryCardNumber');
      const handleChangeBeneficiaryEncryptedCardNumber = changeProvider('beneficiaryEncryptedCardNumber');
      const handleChangeBeneficiaryCardExpiryDate = changeProvider('beneficiaryCardExpiryDate');
      const handleChangeBeneficiaryRelationship = changeProvider('beneficiaryRelationship');
      const handleChangeBeneficiaryAccountIdentifierType = changeProvider('beneficiaryAccountIdentifierType');
      const handleChangeBeneficiaryAccountIdentifierValue = changeProvider('beneficiaryAccountIdentifierValue');
      const handleChangeBeneficiaryCardToken = changeProvider('beneficiaryCardToken');
      const handleChangeBeneficiaryContactCountryCode = changeProvider('beneficiaryContactCountryCode');
      const handleChangeBeneficiaryNameLocalLanguage = changeProvider('beneficiaryNameLocalLanguage');
      const handleChangeBeneficiaryRoutingCodeType1 = changeProvider('beneficiaryRoutingCodeType1');
      const handleChangeBeneficiaryRoutingCodeValue1 = changeProvider('beneficiaryRoutingCodeValue1');
      const handleChangeBeneficiaryRoutingCodeType2 = changeProvider('beneficiaryRoutingCodeType2');
      const handleChangeBeneficiaryRoutingCodeValue2 = changeProvider('beneficiaryRoutingCodeValue2');
      const handleChangeBeneficiaryRoutingCodeType3 = changeProvider('beneficiaryRoutingCodeType3');
      const handleChangeBeneficiaryRoutingCodeValue3 = changeProvider('beneficiaryRoutingCodeValue3');

      return (stateOfPopup) => {
        return (
          <Popup
            caption={(
              <div className="layoutRow fhaS fvaC w">
                <div>Add manual transaction</div>
                <div className="mh30 fw3 rlv st-2">|</div>
                <div className="f12 fx1 wmin0 tov ov wsNW">Payout ID: {payoutId}</div>
              </div>
            )}
            onCancel={close}
            disabled={stateOfPopup.clicked} // TODO: validation
            // disabled={stateOfPopup.clicked && invalidAssetAmount}
            onSave={() => {
              // if (invalidAssetAmount) {
              //   setPopupState({
              //     clicked: true,
              //   });
              //   return;
              // }

              setPopupState({
                loading: true,
              });

              const remitter = {
                nium_account_id: trim(stateOfPopup.remitterNiumAccountId),
                fiat_code: trim(stateOfPopup.remitterFiatCode),
                name: trim(stateOfPopup.remitterName),
                identification_type: trim(stateOfPopup.remitterIdentificationType),
                identification_number: trim(stateOfPopup.remitterIdentificationNumber),
                country_code: trim(stateOfPopup.remitterCountryCode),
                address: trim(stateOfPopup.remitterAddress),
                source_of_income: trim(stateOfPopup.remitterSourceOfIncome),
                contact_number: trim(stateOfPopup.remitterContactNumber),
                dob: trim(stateOfPopup.remitterDob),
                city: trim(stateOfPopup.remitterCity),
                postcode: trim(stateOfPopup.remitterPostcode),
                state: trim(stateOfPopup.remitterState),
                source_of_funds: trim(stateOfPopup.remitterSourceOfFunds),
                place_of_birth: trim(stateOfPopup.remitterPlaceOfBirth),
                nationality: trim(stateOfPopup.remitterNationality),
                occupation: trim(stateOfPopup.remitterOccupation),
              };

              const beneficiary = {
                merchant_id: trim(stateOfPopup.beneficiaryMerchantId),
                name: trim(stateOfPopup.beneficiaryName),
                address: trim(stateOfPopup.beneficiaryAddress),
                city: trim(stateOfPopup.beneficiaryCity),
                state: trim(stateOfPopup.beneficiaryState),
                postcode: trim(stateOfPopup.beneficiaryPostcode),
                country_code: trim(stateOfPopup.beneficiaryCountryCode),
                email: trim(stateOfPopup.beneficiaryEmail),
                account_type: trim(stateOfPopup.beneficiaryAccountType),
                contact_number: trim(stateOfPopup.beneficiaryContactNumber),
                dob: trim(stateOfPopup.beneficiaryDob),
                wallet_id: trim(stateOfPopup.beneficiaryWalletId),
                account_number: trim(stateOfPopup.beneficiaryAccountNumber),
                bank_account_type: trim(stateOfPopup.beneficiaryBankAccountType),
                bank_name: trim(stateOfPopup.beneficiaryBankName),
                bank_code: trim(stateOfPopup.beneficiaryBankCode),
                identification_type: trim(stateOfPopup.beneficiaryIdentificationType),
                identification_value: trim(stateOfPopup.beneficiaryIdentificationValue),
                card_number: trim(stateOfPopup.beneficiaryCardNumber),
                encrypted_card_number: trim(stateOfPopup.beneficiaryEncryptedCardNumber),
                card_expiry_date: trim(stateOfPopup.beneficiaryCardExpiryDate),
                relationship: trim(stateOfPopup.beneficiaryRelationship),
                account_identifier_type: trim(stateOfPopup.beneficiaryAccountIdentifierType),
                account_identifier_value: trim(stateOfPopup.beneficiaryAccountIdentifierValue),
                card_token: trim(stateOfPopup.beneficiaryCardToken),
                contact_country_code: trim(stateOfPopup.beneficiaryContactCountryCode),
                name_local_language: trim(stateOfPopup.beneficiaryNameLocalLanguage),
                routing_code_type_1: trim(stateOfPopup.beneficiaryRoutingCodeType1),
                routing_code_value_1: trim(stateOfPopup.beneficiaryRoutingCodeValue1),
                routing_code_type_2: trim(stateOfPopup.beneficiaryRoutingCodeType2),
                routing_code_value_2: trim(stateOfPopup.beneficiaryRoutingCodeValue2),
                routing_code_type_3: trim(stateOfPopup.beneficiaryRoutingCodeType3),
                routing_code_value_3: trim(stateOfPopup.beneficiaryRoutingCodeValue3),
              };

              const params = {
                tx_number: trim(stateOfPopup.txNumber),
                remitter,
                beneficiary,
                status: trim(stateOfPopup.status),
                sub_status: trim(stateOfPopup.subStatus),
                status_description: trim(stateOfPopup.statusDescription),
              };
              apiAdminPayoutNiumManualUpdate(params).finally((error) => {
                setPopupState({
                  loading: false,
                });
                if (error) {
                  return;
                }
                update();
                openV1PopupInfo(['Transaction has been added']);
                close();
              });
            }}
          >
            <WrapperWithLoading
              loading={stateOfPopup.loading}
            >
              <div>
                <TextField
                  className="mt20"
                  label="TX number"
                  value={stateOfPopup.txNumber}
                  onChange={handleChangeTxNumber}
                />
                <Select3
                  className="mt20"
                  label="Status"
                  value={stateOfPopup.status}
                  onChange={handleChangeStatus}
                  items={STATUSES}
                />
                <TextField
                  className="mt20"
                  label="Sub status"
                  value={stateOfPopup.subStatus}
                  onChange={handleChangeSubStatus}
                />
                <TextField
                  className="mt20"
                  label="Status description"
                  value={stateOfPopup.statusDescription}
                  onChange={handleChangeStatusDescription}
                />
              </div>

              <hr className="mt20"/>
              <div>
                <h3>Remitter</h3>
                <TextField
                  className="mt20"
                  label="Nium account ID"
                  value={stateOfPopup.remitterAccountId}
                  onChange={handleChangeRemitterNiumAccountId}
                />
                <Select3
                  className="mt20"
                  label="Fiat code"
                  value={stateOfPopup.remitterFiatCode}
                  onChange={handleChangeRemitterFiatCode}
                  propName="id"
                  propValue="id"
                  items={CURRENCY_ITEMS}
                />
                <TextField
                  className="mt20"
                  label="Name"
                  value={stateOfPopup.remitterName}
                  onChange={handleChangeRemitterName}
                />
                <Select3
                  className="mt20"
                  label="Identification type"
                  value={stateOfPopup.remitterIdentificationType}
                  onChange={handleChangeRemitterIdentificationType}
                  items={REMITTER_IDENTIFICATION_TYPES}
                />
                <TextField
                  className="mt20"
                  label="Identification number"
                  value={stateOfPopup.remitterIdentificationNumber}
                  onChange={handleChangeRemitterIdentificationNumber}
                />
                <TextField
                  className="mt20"
                  label="Country code"
                  value={stateOfPopup.remitterCountryCode}
                  onChange={handleChangeCountryCode}
                />
                <TextField
                  className="mt20"
                  label="Address"
                  value={stateOfPopup.remitterAddress}
                  onChange={handleChangeRemitterAddress}
                />
                <TextField
                  className="mt20"
                  label="Source of income"
                  value={stateOfPopup.remitterSourceOfIncome}
                  onChange={handleChangeRemitterSourceOfIncome}
                />
                <TextField
                  className="mt20"
                  label="Contact number"
                  value={stateOfPopup.remitterContactNumber}
                  onChange={handleChangeRemitterContactNumber}
                />
                <TextField
                  className="mt20"
                  label="Dob"
                  value={stateOfPopup.remitterDob}
                  onChange={handleChangeRemitterDob}
                />
                <TextField
                  className="mt20"
                  label="City"
                  value={stateOfPopup.remitterCity}
                  onChange={handleChangeRemitterCity}
                />
                <TextField
                  className="mt20"
                  label="Postcode"
                  value={stateOfPopup.remitterPostcode}
                  onChange={handleChangeRemitterPostcode}
                />
                <TextField
                  className="mt20"
                  label="State"
                  value={stateOfPopup.remitterState}
                  onChange={handleChangeRemitterState}
                />
                <TextField
                  className="mt20"
                  label="Source of funds"
                  value={stateOfPopup.remitterSourceOfFunds}
                  onChange={handleChangeRemitterSourceOfFunds}
                />
                <TextField
                  className="mt20"
                  label="Place of birth"
                  value={stateOfPopup.remitterPlaceOfBirth}
                  onChange={handleChangeRemitterPlaceOfBirth}
                />
                <TextField
                  className="mt20"
                  label="Nationality"
                  value={stateOfPopup.remitterNationality}
                  onChange={handleChangeRemitterNationality}
                />
                <TextField
                  className="mt20"
                  label="Occupation"
                  value={stateOfPopup.remitterOccupation}
                  onChange={handleChangeRemitterOccupation}
                />
              </div>

              <hr className="mt20"/>
              <div>
                <h3>Beneficiary</h3>
                <TextField
                  className="mt20"
                  label="Merchant ID"
                  value={stateOfPopup.beneficiaryMerchantId}
                  onChange={handleChangeBeneficiaryMerchantId}
                />
                <TextField
                  className="mt20"
                  label="Name"
                  value={stateOfPopup.beneficiaryName}
                  onChange={handleChangeBeneficiaryName}
                />
                <TextField
                  className="mt20"
                  label="Address"
                  value={stateOfPopup.beneficiaryAddress}
                  onChange={handleChangeBeneficiaryAddress}
                />
                <TextField
                  className="mt20"
                  label="City"
                  value={stateOfPopup.beneficiaryCity}
                  onChange={handleChangeBeneficiaryCity}
                />
                <TextField
                  className="mt20"
                  label="State"
                  value={stateOfPopup.beneficiaryState}
                  onChange={handleChangeBeneficiaryState}
                />
                <TextField
                  className="mt20"
                  label="Postcode"
                  value={stateOfPopup.beneficiaryPostcode}
                  onChange={handleChangeBeneficiaryPostcode}
                />
                <TextField
                  className="mt20"
                  label="Country code"
                  value={stateOfPopup.beneficiaryCountryCode}
                  onChange={handleChangeBeneficiaryCountryCode}
                />
                <TextField
                  className="mt20"
                  label="Email"
                  value={stateOfPopup.beneficiaryEmail}
                  onChange={handleChangeBeneficiaryEmail}
                />
                <Select3
                  className="mt20"
                  label="Account type"
                  value={stateOfPopup.beneficiaryAccountType}
                  onChange={handleChangeBeneficiaryAccountType}
                  items={['Company', 'Individual']}
                />
                <TextField
                  className="mt20"
                  label="Contact number"
                  value={stateOfPopup.beneficiaryContactNumber}
                  onChange={handleChangeBeneficiaryContactNumber}
                />
                <TextField
                  className="mt20"
                  label="Dob"
                  value={stateOfPopup.beneficiaryDob}
                  onChange={handleChangeBeneficiaryDob}
                />
                <TextField
                  className="mt20"
                  label="Wallet ID"
                  value={stateOfPopup.beneficiaryWalletId}
                  onChange={handleChangeBeneficiaryWalletId}
                />
                <TextField
                  className="mt20"
                  label="Account number"
                  value={stateOfPopup.beneficiaryAccountNumber}
                  onChange={handleChangeBeneficiaryAccountNumber}
                />
                <Select3
                  className="mt20"
                  label="Bank account type"
                  value={stateOfPopup.beneficiaryBankAccountType}
                  onChange={handleChangeBeneficiaryBankAccountType}
                  items={['Checking', 'Saving', 'Maestra']}
                />
                <TextField
                  className="mt20"
                  label="Bank name"
                  value={stateOfPopup.beneficiaryBankName}
                  onChange={handleChangeBeneficiaryBankName}
                />
                <TextField
                  className="mt20"
                  label="Bank code"
                  value={stateOfPopup.beneficiaryBankCode}
                  onChange={handleChangeBeneficiaryBankCode}
                />
                <Select3
                  className="mt20"
                  label="Identification type"
                  value={stateOfPopup.beneficiaryIdentificationType}
                  onChange={handleChangeBeneficiaryIdentificationType}
                  items={BENEFICIARY_IDENTIFICATION_TYPES}
                />
                <TextField
                  className="mt20"
                  label="Identification value"
                  value={stateOfPopup.beneficiaryIdentificationValue}
                  onChange={handleChangeBeneficiaryIdentificationValue}
                />
                <TextField
                  className="mt20"
                  label="Card number"
                  value={stateOfPopup.beneficiaryCardNumber}
                  onChange={handleChangeBeneficiaryCardNumber}
                />
                <TextField
                  className="mt20"
                  label="Encrypted card number"
                  value={stateOfPopup.beneficiaryEncryptedCardNumber}
                  onChange={handleChangeBeneficiaryEncryptedCardNumber}
                />
                <TextField
                  className="mt20"
                  label="Card expiry date"
                  value={stateOfPopup.beneficiaryCardExpiryDate}
                  onChange={handleChangeBeneficiaryCardExpiryDate}
                />
                <TextField
                  className="mt20"
                  label="Relationship"
                  value={stateOfPopup.beneficiaryRelationship}
                  onChange={handleChangeBeneficiaryRelationship}
                />
                <TextField
                  className="mt20"
                  label="Account identifier type" // TODO
                  value={stateOfPopup.beneficiaryAccountIdentifierType}
                  onChange={handleChangeBeneficiaryAccountIdentifierType}
                />
                <TextField
                  className="mt20"
                  label="Account identifier value"
                  value={stateOfPopup.beneficiaryAccountIdentifierValue}
                  onChange={handleChangeBeneficiaryAccountIdentifierValue}
                />
                <TextField
                  className="mt20"
                  label="Card token"
                  value={stateOfPopup.beneficiaryCardToken}
                  onChange={handleChangeBeneficiaryCardToken}
                />
                <TextField
                  className="mt20"
                  label="Contact country code"
                  value={stateOfPopup.beneficiaryContactCountryCode}
                  onChange={handleChangeBeneficiaryContactCountryCode}
                />
                <TextField
                  className="mt20"
                  label="Name local language"
                  value={stateOfPopup.beneficiaryNameLocalLanguage}
                  onChange={handleChangeBeneficiaryNameLocalLanguage}
                />
                <TextField
                  className="mt20"
                  label="Routing code type 1"
                  value={stateOfPopup.beneficiaryRoutingCodeType1}
                  onChange={handleChangeBeneficiaryRoutingCodeType1}
                />
                <TextField
                  className="mt20"
                  label="Routing code value 1"
                  value={stateOfPopup.beneficiaryRoutingCodeValue1}
                  onChange={handleChangeBeneficiaryRoutingCodeValue1}
                />
                <TextField
                  className="mt20"
                  label="Routing code type 2"
                  value={stateOfPopup.beneficiaryRoutingCodeType2}
                  onChange={handleChangeBeneficiaryRoutingCodeType2}
                />
                <TextField
                  className="mt20"
                  label="Routing code value 2"
                  value={stateOfPopup.beneficiaryRoutingCodeValue2}
                  onChange={handleChangeBeneficiaryRoutingCodeValue2}
                />
                <TextField
                  className="mt20"
                  label="Routing code type 3"
                  value={stateOfPopup.beneficiaryRoutingCodeType3}
                  onChange={handleChangeBeneficiaryRoutingCodeType3}
                />
                <TextField
                  className="mt20"
                  label="Routing code value 3"
                  value={stateOfPopup.beneficiaryRoutingCodeValue3}
                  onChange={handleChangeBeneficiaryRoutingCodeValue3}
                />
              </div>
            </WrapperWithLoading>
          </Popup>
        );
      };
    });
  };

  const startPayout = (payoutId) => {
    setState({loading: true});
    apiAdminPayoutNiumStartDirect({payout_id: payoutId}).finally((error) => {
      setState({loading: false});
      error || (
        openV1PopupInfo([
          'Payout has been started',
          'You can view transaction details in the transaction table below.',
        ])
      );
    });
  };

  const forceRefreshLastTransaction = (payoutId) => {
    setState({loading: true});
    apiAdminPayoutNiumManualRefreshTransaction({payout_id: payoutId}).finally((error) => {
      setState({loading: false});
      error || (
        openV1PopupInfo([
          'Payout has been started',
          'You can view transaction details in the transaction table below.',
        ])
      );
    });
  };

  return (state) => {
    return (
      <section>
        <LayoutB>
          <HeaderA>
            <CaptionA
              className="fx1 wmin0"
              description={payoutId}
            >
              Payout details
            </CaptionA>
            <ButtonBack onClick={backLocation}/>
          </HeaderA>

          <WrapperWithLoading loading={state.loading}>
            <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
              <Field label="Payout ID">
                <Tooltip title={payoutId}>
                  {payoutId}
                </Tooltip>
              </Field>
              <Field label="Merchant ID">
                <Tooltip title={state.merchantId}>
                  {state.merchantId}
                </Tooltip>
              </Field>
              <Field label="Merchant name">{state.merchantName}</Field>
              <Field label="Merchant email">
                <Tooltip title={state.merchantEmail}>
                  {state.merchantEmail}
                </Tooltip>
              </Field>
            </div>

            <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
              <Field label="Amount">{state.amount} {state.currency}</Field>
              <Field label="Fee">{state.fee} {state.currency}</Field>
              <Field
                label="Status"
                className={'(c66E3F7).m (cF7E766).a (cF76666).e ' + PAYOUT_STATUS_CLASS_MAP[state.status]}>
                {state.status}
              </Field>
              <Field label="Progress">
                <Tooltip title={PAYOUT_PROGRESS_DESCRIPTION_MAP[state.progress]} disabledCopy>
                  {PAYOUT_PROGRESS_TITLE_MAP[state.progress]}
                </Tooltip>
              </Field>
            </div>

            <div className="mt20 cfx (lt|dF|fhaC|aiC|wmin42|h42|p10|mb15|mr15|r7|bgc0.12)>1">
              <Ripple
                className="bgc0.5:h"
                onClick={() => {
                  openAddManualTransactionWindow(payoutId);
                }}
              >
                <AddIcon className="w20 h20"/>
                <span className="ml10">Add manual transaction</span>
              </Ripple>

              <Ripple
                className="bgc0.25:h"
                onClick={() => {
                  startPayout(payoutId);
                }}
              >
                <SendIcon className="w36 h36"/>
                <span className="ml10">Start a payout (Nium -&gt; Merchant)</span>
              </Ripple>

              <Ripple
                className="bgc0.25:h"
                onClick={() => {
                  forceRefreshLastTransaction(payoutId);
                }}
              >
                <ResendMoneyIcon className="w36 h36"/>
                <span className="ml10">Force refresh last transaction</span>
              </Ripple>
            </div>

            {state.transactions && state.transactions.length ? (
              <TransactionsTable className="mt30" transactions={state.transactions}/>
            ) : null}
          </WrapperWithLoading>
        </LayoutB>
      </section>
    );
  };
});
